/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */
import { defineMessages, useIntl } from 'react-intl-next';

import { cssMap, jsx } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import { StaggeredEntrance } from '@atlaskit/motion';
import { Box, Flex } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { type PlaylistItemData } from './PlaylistItem';
import { SuggestedEmptyView } from './SuggestedEmptyView';

const messages = defineMessages({
	suggested: {
		id: 'ai-audio.playlist-suggested.header',
		defaultMessage: 'Suggested',
		description: 'Header for the suggested items section in the playlist',
	},
} as const);

const styles = cssMap({
	playlist: {
		flex: 1,
		paddingTop: token('space.200'),
		paddingRight: token('space.150'),
		paddingBottom: token('space.150'),
		paddingLeft: token('space.150'),
	},
	sectionHeader: {
		textAlign: 'left',
		paddingLeft: token('space.100'),
		paddingBottom: token('space.100'),
		paddingRight: token('space.050'),
		color: token('color.text.subtle'),
	},
});

interface SuggestedViewProps {
	suggestedItems: PlaylistItemData[];
}

export const SuggestedView = ({ suggestedItems }: SuggestedViewProps) => {
	const { formatMessage } = useIntl();

	return (
		<StaggeredEntrance columns={1}>
			<Flex xcss={styles.playlist} direction="column">
				<Box xcss={styles.sectionHeader}>
					<Heading as="h4" size="small">
						{formatMessage(messages.suggested)}
					</Heading>
				</Box>
				<Flex xcss={styles.playlist} direction="column">
					{suggestedItems.length > 0 ? undefined : <SuggestedEmptyView />}
				</Flex>
			</Flex>
		</StaggeredEntrance>
	);
};
